//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateTipoDocumentos } from "@/typings/store/plugins/easyFirestore/tipoDocumentos";

const getters: GetterTree<StateTipoDocumentos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const tipoDocumentos = {
    firestorePath: "dev/v1/tipoDocumentos",
    firestoreRefType: "collection",
    moduleName: "tipoDocumentos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default tipoDocumentos;
